import { ICampaignFormState, IFormFieldRecord } from "../../App/Typings/Campaigns";
import { CampaignContact, CampaignTypes } from "../../App/Enums/CampaignTypes";

export const defaultFormFields: IFormFieldRecord = {
  email: {
    id: "email",
    enabled: true,
    required: true,
    fieldName: "Email",
    label: "Email Address",
    fieldType: "email",
    fieldTypeLabel: "Email Input",
    textLength: "0",
    dropdownOptions: [],
    adGroupOptions: [],
    order: 0,
    isSearchable: true,
    archived: false,
    key: "email_address",
  },
  optIn: {
    id: "optIn",
    enabled: true,
    required: true,
    fieldName: "Opt-In",
    label: "Opt-In for Additional Communications",
    fieldType: "toggle",
    fieldTypeLabel: "Toggle",
    textLength: "0",
    dropdownOptions: [],
    adGroupOptions: [],
    order: 2,
    isSearchable: true,
    archived: false,
    key: "opt_in_for_additional_communications",
  },
  phone: {
    id: "phone",
    enabled: true,
    required: true,
    fieldName: "Phone",
    label: "Phone Number",
    fieldType: "phone",
    fieldTypeLabel: "Phone Input",
    textLength: "0",
    dropdownOptions: [],
    adGroupOptions: [],
    order: 5,
    isSearchable: true,
    archived: false,
    key: "phone_number",
  },
  recaptcha: {
    id: "recaptcha",
    enabled: true,
    required: true,
    fieldName: "Recaptcha",
    label: "",
    fieldType: "recaptcha",
    fieldTypeLabel: "Text Input",
    textLength: "0",
    dropdownOptions: [],
    adGroupOptions: [],
    order: 99,
    isSearchable: true,
    archived: false,
    key: "recaptcha",
  },
  interestPicker: {
    id: "interestPicker",
    enabled: true,
    required: true,
    fieldName: "Interest Picker",
    label: "Interest Picker",
    fieldType: "interestPicker",
    fieldTypeLabel: "Interest Picker",
    textLength: "0",
    dropdownOptions: [],
    adGroupOptions: [],
    order: 1,
    isSearchable: false,
    archived: false,
    key: "interest_picker",
  },
};

export const InitialValues: ICampaignFormState = {
  campaignName: "",
  campaignType: CampaignTypes.Form,
  clientId: "",
  contactPreference: CampaignContact.Phone,
  startDate: "",
  endDate: "",
  lockedFields: [],
  ongoing: false,
  totalCustomFields: 0,
  welcomeMessage: "",
  welcomeMessageSubject: null,
  submitMessage: "Thank you for your submission!",
  submitButtonText: "Submit",
  labelHistory: {
    firstName: new Set<string>(["First Name"]),
    lastName: new Set<string>(["Last Name"]),
    email: new Set<string>(["Email Address"]),
    phone: new Set<string>(["Phone Number"]),
    location: new Set<string>(["Location"]),
    uploadResume: new Set<string>(["Upload Resume"]),
    areaOfInterest: new Set<string>(["Area Of Interest"]),
  },
  formFields: {
    firstName: {
      enabled: true,
      required: true,
      fieldName: "First Name",
      label: "First Name",
      fieldType: "text",
      fieldTypeLabel: "Text Input",
      textLength: "50",
      dropdownOptions: [],
      order: 0,
      isSearchable: true,
      archived: false,
      adGroupOptions: [],
      key: "first_name",
    },
    lastName: {
      enabled: true,
      required: true,
      fieldName: "Last Name",
      label: "Last Name",
      fieldType: "text",
      fieldTypeLabel: "Text Input",
      textLength: "50",
      dropdownOptions: [],
      order: 1,
      isSearchable: true,
      archived: false,
      adGroupOptions: [],
      key: "last_name",
    },
    email: {
      enabled: false,
      required: false,
      fieldName: "Email",
      label: "Email Address",
      fieldType: "email",
      fieldTypeLabel: "Email Input",
      textLength: "0",
      dropdownOptions: [],
      order: 2,
      isSearchable: true,
      archived: false,
      adGroupOptions: [],
      key: "email_address",
    },
    phone: {
      enabled: true,
      required: true,
      fieldName: "Phone",
      label: "Phone Number",
      fieldType: "phone",
      fieldTypeLabel: "Phone Input",
      textLength: "0",
      dropdownOptions: [],
      adGroupOptions: [],
      order: 3,
      isSearchable: true,
      archived: false,
      key: "phone_number",
    },
    location: {
      enabled: true,
      required: true,
      fieldName: "Location",
      label: "Location",
      fieldType: "text",
      fieldTypeLabel: "Text Input",
      textLength: "255",
      dropdownOptions: [],
      order: 4,
      isSearchable: true,
      archived: false,
      adGroupOptions: [],
      key: "location",
    },
    uploadResume: {
      enabled: false,
      required: false,
      fieldName: "Upload Resume",
      label: "Upload Resume",
      fieldType: "upload",
      fieldTypeLabel: "File Upload",
      textLength: "0",
      dropdownOptions: [],
      order: 5,
      isSearchable: true,
      archived: false,
      adGroupOptions: [],
      key: "upload_resume",
    },
    areaOfInterest: {
      enabled: false,
      required: false,
      fieldName: "Area Of Interest",
      label: "Area Of Interest",
      fieldType: "dropdown",
      fieldTypeLabel: "Dropdown",
      textLength: "0",
      dropdownOptions: [],
      order: 6,
      isSearchable: true,
      archived: false,
      adGroupOptions: [],
      key: "area_of_interest",
    },
  },
};
